export default "__VITE_ASSET___0Sy8r5c__"